<script setup lang="ts">

import { onMounted } from "vue";
import { useViewModelInstance } from "@app/MyGarage";
import { useBackButton } from "@app/Components/Utilities";

import CarbucksRewards from "./Features/CarbucksRewards.vue";
import CarbucksProtect from "./Features/CarbucksProtect.vue";
import CarbucksGuarantee from "./Features/CarbucksGuarantee.vue";
import MechanicalProtectionFeature from "./Features/MechanicalProtectionFeature.vue";
import TheftRecoveryFeature from "./Features/TheftRecoveryFeature.vue";
import RoadsideAssistanceFeature from "./Features/RoadsideAssistanceFeature.vue";

const model = await useViewModelInstance();

onMounted( () =>
{
    useBackButton();
} );

</script>

<template>

    <div class="bg-gradient-to-b from-gray-900 via-30% via-gray-850 to-gray-900 dark:text-white
                text-base lg:text-lg 3xl:text-xl px-4 3xl:px-6
                w-full h-full overflow-y-auto overflow-x-hidden 
                flex flex-col gap-4 lg:gap-8 3xl:gap-8 pb-12">
                    
        <!-- PAGE HEADER -->
        <div class="mt-6 px-4 text-center">
            <h2 class="text-lg lg:text-xl 3xl:text-2xl tracking-wider flex flex-col justify-center items-center font-bold">
                <!-- <img class="h-20 3xl:h-28 -mb-3 3xl:-mb-5 grayscale brightness-[200%] opacity-20" src="@/assets/images/carbucks-dark-mode.png" /> -->
                {{ model.carePlan.title }}
            </h2>
            <p class="text-sm lg:text-base 3xl:text-xl pt-3 3xl:pt-4 text-white/60">
                Your Care Plan holds all the important details and documents that protect your car
            </p>
        </div>

        <CarbucksRewards
            v-if="model.carePlan.carbucksRewards.isEnabled"
            v-model="model.carePlan" 
            :key="model.$updateKey" 
        />

        <CarbucksProtect 
            v-if="model.carePlan.carbucksProtect.isEnabled"
            v-model="model.carePlan.carbucksProtect" 
            :key="model.$updateKey" 
        />
        
        <CarbucksGuarantee 
            v-if="model.carePlan.carbucksGuarantee.isEnabled"
            v-model="model.carePlan.carbucksGuarantee" 
            :key="model.$updateKey" 
        />

        <MechanicalProtectionFeature 
            v-if="model.carePlan.mechanicalProtection.isEnabled"
            v-model="model.carePlan.mechanicalProtection" 
            :key="model.$updateKey" 
        />

        <RoadsideAssistanceFeature 
            v-if="model.carePlan.roadsideAssistance.isEnabled"
            v-model="model.carePlan.roadsideAssistance" 
            :key="model.$updateKey" 
        />

        <TheftRecoveryFeature 
            v-if="model.carePlan.theftRecovery.isInstalled"
            v-model="model.carePlan.theftRecovery" 
            :key="model.$updateKey"
        />        

    </div>

</template>